import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import EmailCampaignAppResource from "./EmailCampaignAppResource";

class EmailCampaignMessageAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'email-campaign-message';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'emails/campaigns/messages';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'uuid',
      'emailCampaignUuid',
      'title',
      'timing',
      'templateId',
      'isRepetitive',
      'isActive',
      'meta',
      'campaign',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      campaign: EmailCampaignAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      campaign: 'email_campaign_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      title: {
        type: 'string',
        presence: true,
        length: {
          minimum: 1,
          maximum: 255,
        },
      },
      emailCampaignUuid: {
        type: 'string',
        presence: true,
      },
      timing: {
        numericality: true,
      },
      templateId: {
        type: 'string',
      },
      isRepetitive: {
        type: 'boolean',
      },
      isActive: {
        type: 'boolean',
      },
      meta: {},
    };
  }

}

export default EmailCampaignMessageAppResource;
